import React, { useState } from "react";
import FormField from "./FormField";
import { formInputStyles } from "../../constants/styles";
import { right } from "../../../utils/directions";
import styled from "styled-components";

const PasswordField = ({
  name,
  id,
  control,
  placeholder,
  defaultValue = "",
  style = formInputStyles,
  disabled = false,
  rules = {},
  autoComplete = "current-password",
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="position-relative w-100">
      <FormField
        name={name}
        id={id}
        control={control}
        component="input"
        type={showPassword ? "text" : "password"}
        defaultValue={defaultValue}
        placeholder={placeholder}
        style={style}
        disabled={disabled}
        rules={rules}
        autoComplete={autoComplete}
        {...props}
      />
      <PasswordToggleButton
        type="button"
        className="btn position-absolute"
        onClick={() => setShowPassword(!showPassword)}
      >
        <i
          className={`fi fi-rr-${
            showPassword ? "eye-crossed" : "eye"
          }`}
          style={{
            fontSize: "14px",
            color: "#666",
            position: "relative",
            top: "1px",
          }}
        >        </i>
      </PasswordToggleButton>
    </div>
  );
};

export default PasswordField;

// Styled Components
const PasswordToggleButton = styled.button`
  ${right}: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;
